import Vue from "vue"
import Vuetify from "vuetify/lib/framework"
import he from "vuetify/lib/locale/he"

Vue.use(Vuetify)
export const colors = {
  primary: "#F33015",
  secondary: "#000000",
  secondaryLight: "#FFE9DA",
  black: "#000000",
  textColor: "#606060",
  background: "#FFE9DA",
  accent: "#82b1ff",
  error: "#e05b5b",
  info: "#2196f3",
  success: "#78c485",
  warning: "#ffc107",
  lightGrey: "#b8b7b7",
  lightGreySecondary: "#eee",
  orange: "#f36515",
  azure: "#0FADE9",
  lightAzure: "#CDF1FF",
  initial: "revert",
  textColorPrimary: "#000",
  textColorSecondary: "#11A6DE",
  backgroundWarm: "#ffe9da",
  backgroundCold: "#cdf1ff",
  bibleGreen: "#01462A",
  gold: "#876109",
  backgroundGreen: "#01713F",
  lightGold: "#BF9364",
  /******************
   * figma colors:  *
   ******************/ 
  darkGray: "#606060",
  lightGray: "#c4c4c4",
  tanachiGreen: "#01462a",
  mediumGreen: "#01713f",
  lightGreen: "#00a650",
  red: "#a02f1c",
  tanachiDark: "#876109",
  tanachiLight: "#c09365",
  tanachiDarkGray: "#2b2a2b",
  //point types colors
  meeting: "#b95208",
  battle: "#8a131a",
  speech: "#2099a9",
  generic: "#22398a",
}
export default new Vuetify({
  rtl: true,
  lang: {
    locales: { he },
    current: "he",
  },
  icons: {
    iconfont: "mdiSvg",
  },
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        ...colors,
      },
    },
  },
})
